import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Configurator from "@/pages/Configurator";
import Quotations from "@/pages/Quotations";
import QuotationDetail from "@/pages/QuotationDetail";
import MasterData from "@/pages/admin/MasterData";
import Pricing from "@/pages/admin/Pricing";
import Users from "@/pages/admin/Users";
import Mezzanine from "@/pages/Mezzanine";
import MezzanineQuotations from "@/pages/MezzanineQuotations";
import MezzanineDetail from "@/pages/MezzanineDetail";
import MezzanineSettings from "@/pages/admin/MezzanineSettings";
import Slotted from "@/pages/Slotted";
import SlottedQuotations from "@/pages/SlottedQuotations";
import SlottedDetail from "@/pages/SlottedDetail";
import SlottedSettings from "@/pages/admin/SlottedSettings";
import FloorPlans from "@/pages/FloorPlans";
import FloorPlanEditor from "@/pages/FloorPlanEditor";
import FloorPlanQuotations from "@/pages/FloorPlanQuotations";
import FloorPlanQuotationDetail from "@/pages/FloorPlanQuotationDetail";
import FloorPlanPrint from "@/pages/FloorPlanPrint";
import RackLibrary from "@/pages/admin/RackLibrary";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurator"
              element={
                <ProtectedRoute>
                  <Configurator />
                </ProtectedRoute>
              }
            />
            <Route
              path="/quotations"
              element={
                <ProtectedRoute>
                  <Quotations />
                </ProtectedRoute>
              }
            />
            <Route
              path="/quotations/:id"
              element={
                <ProtectedRoute>
                  <QuotationDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/master-data"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <MasterData />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/pricing"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <Pricing />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/users"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <Users />
                </ProtectedRoute>
              }
            />
            <Route
              path="/mezzanine"
              element={
                <ProtectedRoute>
                  <Mezzanine />
                </ProtectedRoute>
              }
            />
            <Route
              path="/mezzanine-quotations"
              element={
                <ProtectedRoute>
                  <MezzanineQuotations />
                </ProtectedRoute>
              }
            />
            <Route
              path="/mezzanine-quotations/:id"
              element={
                <ProtectedRoute>
                  <MezzanineDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/mezzanine-settings"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <MezzanineSettings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/slotted"
              element={
                <ProtectedRoute>
                  <Slotted />
                </ProtectedRoute>
              }
            />
            <Route
              path="/slotted-quotations"
              element={
                <ProtectedRoute>
                  <SlottedQuotations />
                </ProtectedRoute>
              }
            />
            <Route
              path="/slotted-quotations/:id"
              element={
                <ProtectedRoute>
                  <SlottedDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/slotted-settings"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <SlottedSettings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/floorplan"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <FloorPlans />
                </ProtectedRoute>
              }
            />
            <Route
              path="/floorplan/new"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <FloorPlanEditor />
                </ProtectedRoute>
              }
            />
            <Route
              path="/floorplan/:id"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <FloorPlanEditor />
                </ProtectedRoute>
              }
            />
            <Route
              path="/floorplan/:id/cad"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <FloorPlanPrint />
                </ProtectedRoute>
              }
            />
            <Route
              path="/floorplan-quotations"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <FloorPlanQuotations />
                </ProtectedRoute>
              }
            />
            <Route
              path="/floorplan-quotations/:id"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <FloorPlanQuotationDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/rack-library"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <RackLibrary />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" toastOptions={{ style: { borderRadius: 0 } }} />
      </AuthProvider>
    </div>
  );
}

export default App;
